module.exports = __webpack_public_path__ + "img/img63.1c30a4ae.png";